// utils/modulePermissionList.js
export const MODULE_PERMISSION_LIST = [
  {
    key: "dashboard",
    label: "Dashboard",
    children: [
      {
        key: "dashboard_view",
        page: "dashboard",
        label: "Dashboard",
        actions: ["view"],
      },
    ],
  },

  {
    key: "user_management",
    label: "User Management",
    children: [
      {
        key: "user_management",
        page: "user_management",
        label: "User Management",
        actions: ["view"],
      },
      {
        key: "all_members",
        page: "all_members",
        label: "All Members",
        actions: ["view", "delete"],
      },
      {
        key: "paid_members",
        page: "paid_members",
        label: "Paid Members",
        actions: ["view", "create", "edit", "delete"],
      },
      {
        key: "deleted_members",
        page: "deleted_members",
        label: "Deleted Members",
        actions: ["view", "delete"],
      },
      {
        key: "visitors",
        page: "visitors",
        label: "Visitors",
        actions: ["view"],
      },
      {
        key: "bulk_email",
        page: "bulk_email",
        label: "Bulk Email",
        actions: ["view", "create", "edit", "delete"],
      },
      {
        key: "bulk_sms",
        page: "bulk_sms",
        label: "Bulk SMS",
        actions: ["view", "create", "edit", "delete"],
      },
    ],
  },
  {
    key: "profile_management",
    label: "Profile Management",
    children: [
      {
        key: "profile_management",
        page: "profile_management",
        label: "Profile Management",
        actions: ["view", "edit", "delete"],
      },
      {
        key: "profile_approval",
        page: "profile_approval",
        label: "Profile Approval",
        actions: ["view", "edit", "delete"],
      },
      {
        key: "document_approval",
        page: "document_approval",
        label: "Document Approval",
        actions: ["view", "edit", "delete"],
      },
      {
        key: "photo_approval",
        page: "photo_approval",
        label: "Photo Approval",
        actions: ["view"],
      }
    ],
  },
  {
    key: "attribute",
    label: "Attribute",
    children: [
      {
        key: "attribute",
        page: "attribute",
        label: "Attribute",
        actions: ["view"],
      },
      {
        key: "religion",
        page: "religion",
        label: "Religion",
        actions: ["view", "create", "edit", "delete"],
      },
      {
        key: "caste",
        page: "caste",
        label: "Caste",
        actions: ["view", "create", "edit", "delete"],
      },
      {
        key: "sub_caste",
        page: "sub_caste",
        label: "Sub Caste",
        actions: ["view", "create", "edit", "delete"],
      },
      {
        key: "gotra",
        page: "gotra",
        label: "Gotra",
        actions: ["view", "create", "edit", "delete"],
      },
      {
        key: "language",
        page: "language",
        label: "Language",
        actions: ["view", "create", "edit", "delete"],
      },
      {
        key: "occupation",
        page: "occupation",
        label: "Occupation",
        actions: ["view", "create", "edit", "delete"],
      },
      {
        key: "working_with",
        page: "working_with",
        label: "Working With",
        actions: ["view", "create", "edit", "delete"],
      },
      {
        key: "hobbies",
        page: "hobbies",
        label: "Hobbies",
        actions: ["view", "create", "edit", "delete"],
      },
      {
        key: "education",
        page: "education",
        label: "Education",
        actions: ["view", "create", "edit", "delete"],
      },
      {
        key: "professional_education",
        page: "professional_education",
        label: "Professional Education",
        actions: ["view", "create", "edit", "delete"],
      },
      {
        key: "matchmaking_compatibility",
        page: "matchmaking_compatibility",
        label: "Matchmaking Compatibility",
        actions: ["view"],
      },
      {
        key: "country",
        page: "country",
        label: "Country",
        actions: ["view", "create", "edit", "delete"],
      },
      {
        key: "state",
        page: "state",
        label: "State",
        actions: ["view", "create", "edit", "delete"],
      },
      {
        key: "city",
        page: "city",
        label: "City",
        actions: ["view", "create", "edit", "delete"],
      },
      
    ],
  },

  {
    key: "agent",
    label: "Agent",
    children: [
      {
        key: "agent",
        page: "agent",
        label: "Agent",
        actions: ["view"],
      },
      {
        key: "add_agent",
        page: "add_agent",
        label: "Add Agent",
        actions: ["view", "create"],
      },
      {
        key: "view_agent",
        page: "view_agent",
        label: "View Agent",
        actions: ["view", "edit", "delete"],
      },
      {
        key: "view_lead",
        page: "view_lead",
        label: "View Lead",
        actions: ["view", "edit", "delete"],
      },
      {
        key: "agent_pay_now",
        page: "agent_pay_now",
        label: "Agent Pay Now",
        actions: ["view", "create"],
      },
      {
        key: "agent_pending_approval_leads",
        page: "agent_pending_approval_leads",
        label: "Pending Approval Leads",
        actions: ["view", "create"],
      },
    ],
  },

  {
    key: "staff_member_login",
    label: "Staff Member Login",
    children: [
      {
        key: "staff_member_login",
        page: "staff_member_login",
        label: "Staff Member Login",
        actions: ["view"],
      },
    ],
  },

  {
    key: "membership_plans",
    label: "Membership Plans",
    children: [
      {
        key: "membership_plans",
        page: "membership_plans",
        label: "Membership Plans",
        actions: ["view"],
      },
      {
        key: "view_plan",
        page: "view_plan",
        label: "View Plan",
        actions: ["view","edit"],
      },
      {
        key: "coupon",
        page: "coupon",
        label: "Coupon",
        actions: ["view","create" ,"edit" ,"delete"],
      },
      {
        key: "renew_members_list",
        page: "renew_members_list",
        label: "Renew Members List",
        actions: ["view","edit" ,"delete"],
      },
    ],
  },
  {
    key: "notification",
    label: "Notification",
    children: [
      {
        key: "notification",
        page: "notification",
        label: "Notification",
        actions: ["view"],
      },
      {
        key: "notification",
        page: "notification",
        label: "Notification",
        actions: ["view","create" ,"edit" ,"delete"],
      },
    ]
   }
   ,
  {
    key: "profile_promotion",
    label: "Profile Promotion",
    children: [
      {
        key: "profile_promotion",
        page: "profile_promotion",
        label: "Profile Promotion",
        actions: ["view"],
      },
      {
        key: "profile_promotion",
        page: "profile_promotion",
        label: "Profile Promotion",
        actions: ["view","create" ,"edit" ,"delete"],
      },
    ]
   },
  {
    key: "transaction_history",
    label: "Transaction History",
    children: [
      {
        key: "transaction_history",
        page: "transaction_history",
        label: "Transaction History",
        actions: ["view"],
      },
      {
        key: "export_to_excel",
        page: "export_to_excel",
        label: "Export To Excel",
        actions: ["view"],
      },
    ]
   },
   {
    key: "testimonials",
    label: "Testimonials",
    children: [
      {
        key: "testimonials",
        page: "testimonials",
        label: "Testimonials",
        actions: ["view"],
      },
      {
        key: "add_testimonials_and_success_stories",
        page: "add_testimonials_and_success_stories",
        label: "Add Testimonials & Success Stories",
        actions: ["view", "create"],
      },
      {
        key: "view_testimonials_and_success_stories",
        page: "view_testimonials_and_success_stories",
        label: "View Testimonials & Success Stories",
        actions: ["view","edit","delete"],
      },
    ]
   },
   {
    key: "blog",
    label: "Blog",
    children: [
      {
        key: "blog",
        page: "blog",
        label: "Blog",
        actions: ["view"],
      },
      {
        key: "blog",
        page: "blog",
        label: "Blog",
        actions: ["view", "create", "edit", "delete"],
      },
    ],
   },
   {
    key: "customer_support",
    label: "Customer Support",
    children: [
      {
        key: "customer_support",
        page: "customer_support",
        label: "Customer Support",
        actions: ["view"],
      },
      {
        key: "enquiry_list",
        page: "enquiry_list",
        label: "Enquiry List",
        actions: ["view"],
      },
      {
        key: "reported_chat",
        page: "reported_chat",
        label: "Reported Chat",
        actions: ["view"],
      },
    ]
   },
   {
    key: "cms",
    label: "CMS",
    children: [
       {
        key: "cms",
        page: "cms",
        label: "CMS",
        actions: ["view"],
      },
      {
        key: "slider_image",
        page: "slider_image",
        label: "Slider Image",
        actions: ["view","create","edit","delete"],
      },
      {
        key: "faq",
        page: "faq",
        label: "FAQ",
        actions: ["view","create","edit","delete"],
      },
      {
        key: "feedback",
        page: "feedback",
        label: "Feedback",
        actions: ["view","edit"],
      },
      {
        key: "privacy_policy",
        page: "privacy_policy",
        label: "Privacy Policy",
        actions: ["view","edit"],
      },
      {
        key: "terms_and_conditions",
        page: "terms_and_conditions",
        label: "Terms & Conditions",
        actions: ["view","edit"],
      },
      {
        key: "disclaimer",
        page: "disclaimer",
        label: "Disclaimer",
        actions: ["view","edit"],
      },
      {
        key: "about_us",
        page: "about_us",
        label: "About Us",
        actions: ["view","edit"],
      },
      {
        key: "export_data",
        page: "export_data",
        label: "Export Data",
        actions: ["view"],
      },
      {
        key: "cms_number_stats",
        page: "cms_number_stats",
        label: "Number Stats",
        actions: ["view", "create", "edit", "delete"],
      },
      {
        key: "cms_home_page",
        page: "cms_home_page",
        label: "Home Page",
        actions: ["view", "create", "edit", "delete"],
      },
      {
        key: "cms_state_home_page",
        page: "cms_state_home_page",
        label: "State Home Page",
        actions: ["view", "create", "edit", "delete"],
      },
      {
        key: "cms_bihar_city_page",
        page: "cms_bihar_city_page",
        label: "Bihar City Page",
        actions: ["view", "create", "edit", "delete"],
      },
      {
        key: "cms_religion_page",
        page: "cms_religion_page",
        label: "Religion Page",
        actions: ["view", "create", "edit", "delete"],
      },
      {
        key: "cms_caste_page",
        page: "cms_caste_page",
        label: "Caste Page",
        actions: ["view", "create", "edit", "delete"],
      },
    ]
   }
];
